import React from "react";
import { useMsal } from "@azure/msal-react";
import { Button } from "@mui/material";

const loginRequest = {
  scopes: ["user.Read", "profile", "offline_access"],
};

interface SignInButtonProps {
  variant?: "contained" | "outlined";
}

export const SignInButton: React.FC<SignInButtonProps> = ({ variant }) => {
  const { instance } = useMsal();

  const handleLogin = (loginType: string) => {
    if (loginType === "popup") {
      instance.loginPopup(loginRequest).catch((e: any) => {
        console.log(e);
      });
    } else if (loginType === "redirect") {
      instance.loginRedirect(loginRequest).catch((e: any) => {
        console.log(e);
      });
    }
  };
  return (
    <Button
      variant={variant || "outlined"}
      sx={{ color: (theme) => theme.palette.common.white }}
      onClick={() => handleLogin("redirect")}
    >
      Sign In
    </Button>
  );
};
